import { userTimingArray } from "../config/filter-list";
import {
  capitalizeFirstLetterAfterPrefix,
  isNotEmptyObject,
  metricPrefix,
  RawRumData,
  RawUserTimingData,
} from "../beacon/beacon-util";
import { sendUserTimingsToBeacon } from "../beacon/user-timing";

import {
  LCPAttribution,
  LCPMetricWithAttribution,
  Metric,
} from "web-vitals/attribution";
import { trackingEndpointLogic } from "../tracking/tracking";

export const webVitalsToMetricMap = {
  FCP: "firstContentfulPaint",
  LCP: "largestContentfulPaint",
  CLS: "cumulativeLayoutShift",
  INP: "interactionToNextPaint",
  TTFB: "timeToFirstByte",
};

let collectedBeaconServiceMetrics: RawUserTimingData = {};

/**
 *
 *
 *
 *
 */
const isLCPMetricWithAttribution = (
  metric: Metric,
): metric is LCPMetricWithAttribution =>
  metric.name === "LCP" &&
  (metric as LCPMetricWithAttribution).attribution !== undefined;

export const targetTransform: (a: LCPAttribution) => RawRumData[string] = (
  a,
) => (a.target === "" ? "empty" : a.target ?? "unknown");

const defaultTransform = (
  key: keyof LCPAttribution,
  a: LCPAttribution,
): RawRumData[string] => a[key] as never;

/**
 *
 *
 *
 *
 *
 */
const attributionMap = {
  target: ["LCPElement", targetTransform],
  url: ["LCPURL", (a) => a.url!],
  timeToFirstByte: ["LCPTimeToFirstByte"],
  resourceLoadDelay: ["LCPResourceLoadDelay"],
  resourceLoadDuration: ["LCPResourceLoadDuration"],
  elementRenderDelay: ["LCPElementRenderDelay"],
} satisfies {
  [P in keyof LCPAttribution]: [metricName: string, transform?: (a: LCPAttribution) => RawRumData[string]];
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const collectLCPAttribution = (
  metric: Metric,
  metricsResult: RawRumData,
  prefix: string = metricPrefix,
): void => {
  /*                                 */
  if (!isLCPMetricWithAttribution(metric)) return;

  /*                           */
  const { attribution } = metric;

  Object.entries(attributionMap)
    /*                                              */
    /*                                                                            */
    .filter((mapEntry) => attribution[mapEntry[0]] !== undefined)
    .forEach(
      ([key, [metricName, transform = defaultTransform.bind(null, key)]]) => {
        
        /*                                                                */
        metricsResult[`${prefix}${metricName}`] = transform(attribution);
      },
    );
};

/**
 *
 *
 */
export function performanceBeaconTracker(metric: Metric) {
  const tracking_metrics: RawRumData = {};

  const duration: number = metric.value;
  /*                                        */
  if (duration <= 0) return;

  /*                                         */
  collectLCPAttribution(metric, tracking_metrics);

  /*                                                                  */
  const metricName = webVitalsToMetricMap[metric.name] || metric.name;
  const metricNamePascal: string = capitalizeFirstLetterAfterPrefix(metricName);
  const prefixedMetricName = `${metricPrefix}${metricNamePascal}`;

  /*                               */
  tracking_metrics[prefixedMetricName] = duration;
  trackingEndpointLogic(tracking_metrics);

  /*                                          */
  if (userTimingArray.includes(prefixedMetricName)) {
    collectedBeaconServiceMetrics[prefixedMetricName] = duration;
  }
}

/**
 *
 */
export const flushQueue = async () => {
  if (isNotEmptyObject(collectedBeaconServiceMetrics)) {
    await sendUserTimingsToBeacon(collectedBeaconServiceMetrics);
    collectedBeaconServiceMetrics = {};
  }
};

/*                                                                                    */
/*                                                                                            */
const isSafariPattern = /(Safari|AppleWebKit)/;
const isNotSafariPattern = /(Chrome|CriOS|Edg)/;

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const isSafari = (userAgent = navigator.userAgent): boolean =>
  /*                                                              */
  isSafariPattern.test(userAgent) && !isNotSafariPattern.test(userAgent);
